import styles from '../richText.module.scss'

import type {PropsWithChildren} from 'react'

export const Dfn = ({children}: PropsWithChildren) => (
  <small
    className={styles.dfn}
    data-testid={'_dfn'}
  >
    {children}
  </small>
)
